import styled from 'styled-components'
import { TitleValueBlockV2 } from 'Layout'
import { BREAK_POINT_MD } from '@CSSVars/variables'
import { OUTLINE_COLOR, SELECTED_ITEM_BG_COLOR, CLICKABLE_COLOR, FONT_BASE_COLOR } from '@CSSVars/colors'


export const _ListingDetailKeyContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0 0;
`

export const _FactsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
`

export const _TitleValueBlock = styled(TitleValueBlockV2)`
  margin: -5px 0;
  width: 25%;
  &:first-child {
    margin-bottom: 21px!important;
  }

  @media screen and (max-width: 767px) {
    margin-bottom: 24px;
    width: 50%;
  }
`

export const _AnchorContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

export const _Anchor = styled.button`
  width: 100%;
  height: 44px;
  margin-top: 24px;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: ${FONT_BASE_COLOR};
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid ${OUTLINE_COLOR};
  @media (hover:hover) {
    &:hover {
      color:${CLICKABLE_COLOR};
    }
  }
  :active{
    color: ${SELECTED_ITEM_BG_COLOR};
  }
  @media screen and (max-width: 767px) {
    ${({ listingDetailBtn, isCondo }) => (listingDetailBtn && isCondo && `
      display:none;
   `)}
  }
`

export const _MobileMap = styled.div`
  display: none;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-top: 24px;
    display: block;
    border-radius: 10px;
    overflow: hidden;
  }
`
